module.exports = __webpack_public_path__ + "img/chinesecompany157.3735b327.png";